'use strict';
import { db } from './firebase'

import {
    query,
    getDocs,
    collection,
    where,
} from "firebase/firestore";

const getCode = async (code: string) => {

    const q = query(
        collection(db, `code`),
        where("value", "==", code)
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    return data
};

export {
    getCode,
};
